module.exports = __webpack_public_path__ + "img/frame (246).055d3cf6.jpg";